import styled from 'styled-components';
import { Breadcrumb } from 'components/atoms/breadcrumb';
import { SingleLineEllipsis } from 'components/styles';

export const StyledBreadcrumb = styled(Breadcrumb)`
  padding-bottom: var(--spacing-05);
  ${SingleLineEllipsis};
  width: 100%;
`;
